import { AfterViewInit, Directive, ElementRef, Input, inject } from '@angular/core';

@Directive({
  selector: '[egAutoFocus]',
  standalone: false,
})
export class AutoFocusDirective implements AfterViewInit {
  private elementRef = inject(ElementRef);

  @Input() selector = 'input';

  ngAfterViewInit(): void {
    this.elementRef.nativeElement.querySelector(this.selector)?.focus();
  }
}
